import boxBig from "@/assets/photos/original/big.webp";
import { Skeleton } from "@/components/ui/skeleton";
import { useUser } from "@/firebase";
import { cn } from "@/services/hooks/utils";
import { Link } from "@tanstack/react-router";
import SVGSeparator from "./SVGSeparator";

const HeroImage = () => {
    const { user, isLoading } = useUser();

    const renderCallToAction = () => {
        if (isLoading) {
            return <Skeleton className="w-[250px] h-[60px] bg-orange-500/30" />;
        }
        if (user?.email) {
            return (
                <button
                    type="button"
                    className="bg-primary text-primary-foreground rounded-md text-lg md:text-xl"
                >
                    <Link
                        to="/user/home"
                        className="py-4 px-6 font-raleway block"
                    >
                        Ir a tu suscripción
                    </Link>
                </button>
            );
        }
        return (
            <>
                <div className="flex flex-col items-center lg:flex-row gap-4">
                    <button
                        type="button"
                        className="bg-primary text-primary-foreground rounded-md text-lg md:text-xl hover:shadow-lg"
                    >
                        <Link
                            to="/register/subscriptions"
                            className="py-4 px-6 font-raleway block"
                        >
                            Quiero mi suscripción
                        </Link>
                    </button>
                </div>
                <a
                    href="https://tienda.maifud.cl/"
                    target="_blank"
                    className=" text-white bg-[#7B7D2A] text-center py-2 px-6  rounded-md flex items-center justify-center text-lg hover:shadow-lg"
                    rel="noopener noreferrer"
                >
                    Comprar a granel
                </a>
            </>
        );
    };

    return (
        <>
            <div
                className={cn(
                    "relative lg:pb-8 bg-[#f6e9dd]",
                    user?.email ? "pt-[76px]" : "pt-[116px]",
                )}
            >
                <div className="relative mx-auto flex max-w-7xl flex-col items-center px-4 pt-6 sm:px-8 lg:h-[340px] lg:flex-row lg:px-16 lg:pt-0">
                    {/* <!--Left Col--> */}
                    <div className="relative z-10 flex w-full flex-col items-center justify-center pb-6 text-center md:w-2/4 lg:items-start lg:pl-8 lg:text-left">
                        <h1 className="mt-2 mb-4 px-1 text-3xl font-bold leading-tight lg:my-4 lg:px-0 lg:text-4xl">
                            Ahorra en tus frutas y verduras evitando el
                            desperdicio de alimentos.
                        </h1>
                        <p className="mb-6 mt-2 text-base leading-relaxed sm:text-lg lg:text-2xl">
                            Personaliza el contenido de tu caja y recibe directo
                            en tu puerta
                        </p>
                        <div className="w-full flex flex-col space-y-4 items-center justify-center lg:w-fit lg:items-start lg:justify-start">
                            {renderCallToAction()}
                        </div>
                    </div>
                    {/* <!--Right Col--> */}
                    <div className="w-full pt-2 md:w-2/4 lg:flex lg:justify-end lg:py-6">
                        <img
                            className="z-30 mx-auto w-full max-w-md lg:max-w-none"
                            src={boxBig}
                            alt="Caja de maifud llena de frutas y verduras"
                        />
                    </div>
                </div>
            </div>
            <SVGSeparator />
        </>
    );
};
export default HeroImage;
